import React from "react";

/** Figma chart-candlestick — outer 40×40, leaf inset 12.5% (node 2181:7675) */
const ChartCandlestickIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-10 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%]">
                <svg
                    className={className ?? "block size-full"}
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...rest}
                >
                    <path
                        d="M11 4.33333V11M11 21V24.3333M24.3333 1V4.33333M24.3333 17.6667V22.6667M1 1V27.6667C1 28.5507 1.35119 29.3986 1.97631 30.0237C2.60143 30.6488 3.44928 31 4.33333 31H31M9.33333 11H12.6667C13.5871 11 14.3333 11.7462 14.3333 12.6667V19.3333C14.3333 20.2538 13.5871 21 12.6667 21H9.33333C8.41286 21 7.66667 20.2538 7.66667 19.3333V12.6667C7.66667 11.7462 8.41286 11 9.33333 11ZM22.6667 4.33333H26C26.9205 4.33333 27.6667 5.07953 27.6667 6V16C27.6667 16.9205 26.9205 17.6667 26 17.6667H22.6667C21.7462 17.6667 21 16.9205 21 16V6C21 5.07953 21.7462 4.33333 22.6667 4.33333Z"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    );
};

export default ChartCandlestickIcon;
